export default "__VITE_ASSET__ClXO7Nw5__"